import styled from '@emotion/styled';
import { Group as GroupType, IText } from 'fabric/fabric-impl';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectActiveObjects } from 'modules/template-editor/store/editor/selectors';
import { ShapeType } from '../left-toolbar/add-shape';
import Canvas from './canvas';
import ComplexPlaceholder from './complex-placeholder';
import Figure from './figure';
import Group from './group';
import Image from './image';
import Placeholder from './placeholder';
import Text from './text';
import { theme } from 'styles/theme/theme';

const SHAPE_TYPE_TO_FABRIC_TYPE: Record<ShapeType, string> = {
  rect: 'rect',
  circle: 'circle',
  triangle: 'triangle',
  'right-triangle': 'polygon',
  ellipse: 'ellipse',
  trapezoid: 'polygon',
  pentagon: 'polygon',
  hexagon: 'polygon',
  star: 'polygon',
  diamond: 'polygon',
};

const FIGURE_FABRIC_TYPES = new Set(Object.values(SHAPE_TYPE_TO_FABRIC_TYPE));

function RightToolbar() {
  const activeObjects = useSelector(selectActiveObjects);
  // object
  const someSelect = activeObjects.length > 0;
  const moreSelect = activeObjects.length > 1;
  const singleSelect = activeObjects.length === 1;

  const isText = singleSelect && (activeObjects[0].type === 'i-text' || activeObjects[0].type === 'textbox');
  const isFigure = singleSelect && FIGURE_FABRIC_TYPES.has(activeObjects[0].type ?? '');
  const isPlaceholder = singleSelect && activeObjects[0].type === 'group';
  const isImage = singleSelect && activeObjects[0].type === 'image';
  const isComplex = isPlaceholder && activeObjects[0]?.data?.type === 'composition';

  return (
    <MainBlock>
      {!someSelect && <Canvas />}
      {isFigure && <Figure />}
      {isText && <Text text={activeObjects[0] as IText} />}
      {isPlaceholder && !isComplex && <Placeholder group={activeObjects[0] as GroupType} />}
      {moreSelect && <Group objects={activeObjects} />}
      {isImage && <Image />}
      {isComplex && <ComplexPlaceholder object={activeObjects[0] as GroupType} />}
    </MainBlock>
  );
}

export default RightToolbar;

const MainBlock = styled.div`
  width: 256px;
  min-width: 256px;
  background: ${theme.colors.SurfaceWhite};
  border-left: 1px solid ${theme.colors.DarkBlue100};
  padding: 8px 8px;

  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  letter-spacing: 0.5px;

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 4px;
    background-color: inherit;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.SurfacePlatinum20};
    border-radius: 8px;
  }
`;
